export const IS_PRODUCTION = process.env.DB_ENV === 'production';
export const IS_SERVER = !(typeof window !== 'undefined'
  && typeof window.document !== 'undefined'
  && typeof window.document.createElement !== 'undefined');
